<template>
  <q-select
    :model-value="modelValue"
    class="action-select"
    :options="$mh.asOptions(allowedActions)"
    option-value="value"
    option-label="label"
    emit-value
    map-options
    dense
    @update:model-value="$emit('update:model-value', $event)"
  >
    <template #selected-item="scope">
      <div class="row items-center full-width">
        <div
          class="q-mr-sm"
        >
          <q-icon
            :name="ACTIONS_CONTENT[scope.opt.value].icon"
            :color="ACTIONS_CONTENT[scope.opt.value].iconColor"
            size="xs"
          />
        </div>
        <div
          class="col text-body-em text-grey-9"
          style="font-size: 16px;"
        >
          {{ scope.opt.label }}
        </div>
        <div class="text-caption text-grey-7">
          {{ ACTIONS_CONTENT[scope.opt.value].subtext }}
        </div>
      </div>
    </template>
    <template #option="scope">
      <q-item
        v-bind="scope.itemProps"
        v-on="scope.itemEvents"
      >
        <q-item-section class="col-auto self-start">
          <q-icon
            :name="ACTIONS_CONTENT[scope.opt.value].icon"
            :color="ACTIONS_CONTENT[scope.opt.value].iconColor"
            size="xs"
          />
        </q-item-section>
        <q-item-section class="col">
          <div class="column">
            <div
              class="text-body-em text-grey-9 q-mb-xs"
              style="font-size: 16px;"
            >
              {{ scope.opt.label }}
            </div>
            <div class="text-caption text-grey-7">
              {{ ACTIONS_CONTENT[scope.opt.value].subtext }}
            </div>
          </div>
        </q-item-section>
      </q-item>
    </template>
  </q-select>
</template>

<script>
import { ACTIONS } from 'src/modules/admin/components/ModelForm/components/library/constants'

const ACTIONS_CONTENT = {
  [ACTIONS.LINK]: {
    icon: 'fa fa-cloud-arrow-down',
    iconColor: 'grey',
    subtext: 'Links a new or found copy of the record (will not force update found copies)'
  },
  [ACTIONS.ENABLE_UPDATES]: {
    icon: 'fa fa-link-horizontal',
    iconColor: 'grey',
    subtext: 'Automatically propagate updates to this record to the selected links'
  },
  [ACTIONS.DISABLE_UPDATES]: {
    icon: 'fa fa-link-horizontal-slash',
    iconColor: 'grey',
    subtext: 'Stop automatic updates to the selected links'
  },
  [ACTIONS.FORCE_UPDATE]: {
    icon: 'far fa-arrows-rotate',
    iconColor: 'grey',
    subtext: 'Forcibly update selected links to match the current record'
  },
  [ACTIONS.ARCHIVE]: {
    icon: 'archive',
    iconColor: 'grey',
    subtext: 'Archive the selected links'
  },
  [ACTIONS.UNARCHIVE]: {
    icon: 'unarchive',
    iconColor: 'grey',
    subtext: 'Unarchive the selected links'
  },
  [ACTIONS.UNLINK]: {
    icon: 'fa fa-cloud-slash',
    iconColor: 'grey',
    subtext: 'Detach the selected links from this record'
  }
}
Object.freeze(ACTIONS_CONTENT)

export default {
  name: 'ManageLinksActionsSelect',
  props: {
    modelValue: {
      type: String,
      required: true
    },
    model: {
      type: Object,
      required: false,
      default: null
    },
    loading: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  emits: ['update:model-value'],
  computed: {
    allowedActions () {
      let allowedActions = _.clone(ACTIONS.ALL)
      if (!this.model.archivable || !this.model.isDeletePermitted) {
        allowedActions = _.without(allowedActions, ...ACTIONS.ARCHIVABLE)
      }
      return allowedActions
    }
  },
  created () {
    _.extend(this, { ACTIONS, ACTIONS_CONTENT })
  }
}

</script>

<style lang="scss" scoped>
.action-select {
  :deep(.q-field__control) {
    border-radius: 6px;
  }
  box-shadow: 0 2px 0 0 rgba(10, 13, 18, 0.04);
}
</style>
